import { inject, Injectable } from '@angular/core';

/**
 * Serviço de persistência de dados seguindo padrões do Discover Portal
 * Responsável pelo armazenamento e recuperação de dados no localStorage
 * com sanitização de segurança seguindo patterns do projeto
 */
@Injectable({ providedIn: 'root' })
export class StorageService {
  

  /**
   * Armazena dados no localStorage com sanitização de segurança
   * @param key Chave para armazenamento
   * @param data Dados a serem armazenados
   */
  set<T>(key: string, data: T): void {
    try {
      const jsonString = JSON.stringify(data);
      // Validação básica para evitar XSS
      const sanitized = jsonString.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
      localStorage.setItem(key, sanitized);
    } catch (error) {
      console.error(`❌ StorageService: Error setting data for key ${key}:`, error);
    }
  }

  /**
   * Recupera dados do localStorage
   * @param key Chave para recuperação
   * @returns Dados recuperados ou null se não existir
   */
  get<T>(key: string): T | null {
    try {
      const data = localStorage.getItem(key);
      if (!data) return null;
      return JSON.parse(data) as T;
    } catch (error) {
      console.error(`❌ StorageService: Error getting data for key ${key}:`, error);
      return null;
    }
  }

  /**
   * Remove um item do localStorage
   * @param key Chave para remoção
   */
  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`❌ StorageService: Error removing data for key ${key}:`, error);
    }
  }

  /**
   * Limpa todos os itens do localStorage
   */
  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('❌ StorageService: Error clearing localStorage:', error);
    }
  }

  /**
   * Verifica se uma chave existe no localStorage
   * @param key Chave para verificação
   * @returns true se a chave existir
   */
  exists(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }
}